import { render } from "./PrintButton.vue?vue&type=template&id=0f120f89"
import script from "./PrintButton.vue?vue&type=script&lang=js"
export * from "./PrintButton.vue?vue&type=script&lang=js"

import "./PrintButton.vue?vue&type=style&index=0&id=0f120f89&lang=scss"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__